import type { TrackEntity } from '~/types'

export type TrackingEvent =
  | { type: 'pageview'; entities?: TrackEntity[]; pageId?: number | string }

type Subscriber = (event: TrackingEvent) => void

const subscribers = new Set<Subscriber>()

export function onTrackingEvent(fn: Subscriber): () => void {
  subscribers.add(fn)
  return () => subscribers.delete(fn)
}

export function emitTrackingEvent(event: TrackingEvent): void {
  for (const fn of subscribers) {
    try { fn(event) } catch { /* never let one subscriber break others */ }
  }
}
